import BomArrow from "@assets/images/bom-arrow.svg";
import eyeIcon from "@assets/images/eye.svg";
import infoFilled from "@assets/images/info-filled.svg";
import warningLight from "@assets/images/warning-light.svg";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Tooltip
} from "@material-ui/core";
// import { changeOrderPath } from "@saleor/changeOrderDomestic/urls";
import MyTypography from "@saleor/components/MyTypography";
import StickyHorizontalScrollBar from "@saleor/components/StickyHorizontalScrollBar";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { SalesOrderSortListField } from "@saleor/createOrder/urls";
import { ListOfSaleOrderAndExcelQuery } from "@saleor/graphql";
// import useNavigator from "@saleor/hooks/useNavigator";
import { makeStyles } from "@saleor/macaw-ui";
import { renderCollection } from "@saleor/misc";
import { getArrowDirection } from "@saleor/utils/sort";
import classNames from "classnames";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";

window.moment = moment;
import DecimalFormat from "@saleor/components/DecimalFormat";
import { sortAndMerge } from "@saleor/PendingOrder/utils";
import orderBy from "lodash/orderBy";
import uniq from "lodash/uniq";
import InlineSVG from "react-inlinesvg";

import CollapseSoldTo from "../CollapseSoldTo";

type SoldTo = ListOfSaleOrderAndExcelQuery["listOfSaleOrderAndExcel"]["listOfSaleOrderSap"][0];

interface IOrderListTable {
  soldTo: SoldTo;
  index: number;
  sort: Partial<{ asc: boolean; sort: SalesOrderSortListField }>;
  onSort: (field: SalesOrderSortListField, id?: string) => void;
  isSaleOrderTracking?: boolean;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      overflowX: "auto",
      width: "100%",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderBottom: 0,
      borderRadius: "2px",
      marginBottom: 32,
      cursor: "auto",
      "& .MuiTable-root": {
        borderCollapse: "collapse"
      },
      "& .MuiTableCell-head": {
        border: `1px solid ${theme.palette.grey[300]}`,
        padding: "0 12px",
        minWidth: 160,

        "& *": {
          color: `${theme.palette.grey[900]} !important`
        }
      },
      "& .MuiTableCell-body": {
        border: `1px solid ${theme.palette.grey[300]}`,
        minWidth: 160,
        padding: "0 12px"
      },
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF",
        border: "1px solid #E0E0E0",
        borderLeft: 0,
        borderRight: 0
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 6,
        border: "4px solid transparent",
        backgroundClip: "padding-box",
        height: "6px"
      },
      "& .MuiTableCell-head * ": {
        color: "#222222 !important"
      }
    },
    tableFooter: {
      background: "#f4f7fe",
      padding: "9px 12px",

      "& .MuiTableRow-root": {
        background: "#f4f7fe"
      },
      "& .MuiTableCell-footer": {
        border: `1px solid ${theme.palette.grey[300]}`,
        padding: "0 12px"
      }
    },
    subColumn: {
      minWidth: 80
    },
    infoDark: {
      color: theme.palette.info.dark
    },
    cursorPointer: {
      cursor: "pointer"
    },
    rowOverDue: {
      background: `${theme.palette.scgPrimary.hover} !important`
    },
    title: {
      marginBottom: 24
    },
    flex: { display: "flex", alignItems: "center" },
    firstChild: {
      paddingLeft: 32
    },
    printBtn: {
      padding: "4px 15px",
      borderRadius: "4px",
      background: "#FFFFFF"
    },
    customCell: {
      height: "12px",
      padding: "0.8rem 1.2rem !important"
    },
    noBorder: {
      border: "0 !important"
    },
    thDelivery: {
      background: "#E6F6F8 !important"
    },
    delivery: {
      fontFamily: "ScgFont, sans-serif",
      fontWeight: 400,
      fontSize: "1.4rem",
      lineHeight: "20px",
      display: "flex",
      alignItems: "center"
    },
    borderRight: {
      borderRight: `1px solid ${theme.palette.grey[300]} !important`
    },
    infoFilled: {
      marginLeft: 5
    },
    tooltip: {
      "& .MuiTypography-root": {
        color: "#FFF"
      },
      borderRadius: 4,
      background: theme.palette.grey[600],
      padding: "4px 8px"
    },
    cellHeader: {
      color: theme.palette.grey[600]
    },
    tableContainer: {
      maxHeight: "55vh",
      "& .MuiTableHead-root": {
        position: "sticky",
        top: "-1px",
        left: "0",
        zIndex: "2"
      }
    },
    totalWrapper: {
      minWidth: 130,
      padding: "16.5px 12px",
      background: "#f4f7fe",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRight: "none"
    },
    disabledUnit: {
      color: theme.palette.grey[600]
    },
    flip: {
      transform: "rotate(180deg) scaleX(-1)"
    },
    OrderTrackStatus: {
      width: "8px",
      height: "8px",
      backgroundColor: "#FFC107",
      borderRadius: "100%",
      marginRight: "8px"
    },
    eyeIconStyle: {
      minWidth: 32,
      padding: "0px",
      height: 32
    },
    orderTrackCell: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      whiteSpace: "nowrap"
    },
    rowFlex: {
      display: "flex",
      alignItems: "center",
      width: "100%"
    },
    flexSpace: {
      justifyContent: "space-between"
    }
  }),
  { name: "OrderListTable1" }
);
function formatNumber(value) {
  if (value == null) {
    return "";
  }
  const parsedValue = parseFloat(value);
  const integerFormatter = new Intl.NumberFormat("en-US");
  const decimalFormatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  });

  if (Number.isInteger(parsedValue)) {
    return integerFormatter.format(parsedValue);
  } else {
    return decimalFormatter.format(parsedValue);
  }
}
const TotalText = ({ unit }: { unit: string }) => {
  const classes = useStyles();
  const intl = useIntl();
  return (
    <div style={{ display: "flex", gap: 2 }}>
      <MyTypography variant="subtitle3" style={{ marginRight: 2 }}>
        {intl.formatMessage({
          defaultMessage: "Total"
        })}
      </MyTypography>
      <MyTypography variant="body3" className={classes.disabledUnit}>
        {unit && `(${unit})`}
      </MyTypography>
    </div>
  );
};

const getSummaryEmptyStyle = (index, len) => ({
  borderTop: "none",
  borderBottom: index === len - 1 ? "1px solid #e0e0e0" : "none"
});

const handleOpenNewTab = url => {
  window.open(url, "_blank");
};
const navigateRefOrder = orderNo => {
  const url = `/dashboard/orders/change-order/${orderNo}`;
  handleOpenNewTab(url);
};

const navigateNotRefOrder = orderNo => {
  const url = `/dashboard/orders/not-ref-change-order/${orderNo}`;
  handleOpenNewTab(url);
};

const TableData = ({
  soldTo,
  index,
  sort,
  onSort,
  isSaleOrderTracking
}: IOrderListTable) => {
  const intl = useIntl();
  const classes = useStyles();
  const containerRef = useRef<HTMLDivElement | null>(null);

  const formatDate = "DD/MM/YYYY";
  const [item, setItem] = useState<SoldTo>(soldTo);

  const [tempSaleOrderList, _setTempSaleOrderList] = useState<SoldTo>(soldTo);

  useEffect(() => {
    const list = [...tempSaleOrderList.orderLines];

    const formattedList = list.map(item => ({
      ...item,
      createDate: item?.createDate
        ? moment(item?.createDate, formatDate).toDate()
        : item?.createDate,
      itemNo: parseInt(item?.itemNo, 10),
      poNo: item?.poNo?.toString(),
      orderNo: item?.orderNo?.toString(),
      reqDeliveryDate: item?.reqDeliveryDate
        ? moment(item?.reqDeliveryDate, formatDate).toDate()
        : item?.reqDeliveryDate
    }));
    const secondarySortKeys = ["orderNo", "itemNo"];

    setItem({
      ...item,
      orderLines: sortAndMerge(formattedList, sort, secondarySortKeys).map(
        item => ({
          ...item,
          createDate: item?.createDate
            ? moment(item?.createDate).format(formatDate)
            : item?.createDate,
          itemNo: item?.itemNo?.toString(),
          reqDeliveryDate: item?.reqDeliveryDate
            ? moment(item?.reqDeliveryDate).format(formatDate)
            : item?.reqDeliveryDate
        })
      )
    });
  }, [sort]);

  const mergeUnit = (type: string): string => {
    const { orderLines } = soldTo;
    const totalUnits = orderLines.map(order => {
      switch (type) {
        case "unit":
          return order.unit;
        case "weightUnit":
          return order.weightUnit;
        default:
          break;
      }
      // if (type === "unit") {
      //   switch (order.unit) {
      //     case "ROL":
      //       return "Roll";
      //     case "TON":
      //       return "Ton";
      //     default:
      //       return order.unit;
      //   }
      // }

      // if (type === "weightUnit") {
      //   switch (order.weightUnit) {
      //     case "ROL":
      //       return "Roll";
      //     case "TON":
      //       return "Ton";
      //     default:
      //       return order.weightUnit;
      //   }
      // }
    });
    const totalUniqueUnits = orderBy(uniq(totalUnits));

    return totalUniqueUnits.join("/");
  };

  const isBom = item => item?.bomFlag === true;
  const isChild = item => item?.parentItemNo !== "";
  const isBomParent = item => isBom(item) && !isChild(item);
  const isBomChild = item => isBom(item) && isChild(item);

  const handleOrderTrack = trackingUrl => {
    window.open(trackingUrl, "_blank", "noopener");
  };

  const viewOrder = item => {
    if (item?.isNotRef) {
      navigateNotRefOrder(item?.orderNo);
    } else {
      navigateRefOrder(item?.orderNo);
    }
  };

  const COLUMN_DEFINITIONS = {
    itemStatus: {
      id: "itemStatus",
      header: { defaultMessage: "Item Status" },
      rowSpan: 2
    },
    sapStatus: {
      id: "sapStatus",
      header: { defaultMessage: "SAP Status" },
      rowSpan: 2
    },
    orderTrackingStatus: {
      id: "orderTrackingStatus",
      header: { defaultMessage: "Order Tracking Status" },
      rowSpan: 2
    },
    saleOrganization: {
      id: "saleOrganization",
      header: { defaultMessage: "Sale organization" },
      rowSpan: 2
    },
    orderType: {
      id: "orderType",
      header: { defaultMessage: "Order type" },
      rowSpan: 2
    },
    billTo: {
      id: "billTo",
      header: { defaultMessage: "Bill-to" },
      rowSpan: 2
    },
    shipTo: {
      id: "shipTo",
      header: { defaultMessage: "Ship-to" },
      rowSpan: 2
    },
    unloadingPoint: {
      id: "unloadingPoint",
      header: { defaultMessage: "Unloading Point" },
      rowSpan: 2
    },
    paymentTerm: {
      id: "paymentTerm",
      header: { defaultMessage: "Payment Term" },
      rowSpan: 2
    },
    headerNote: {
      id: "headerNote",
      header: { defaultMessage: "Header Note" },
      rowSpan: 2
    },
    itemNote: {
      id: "itemNote",
      header: { defaultMessage: "Item Note" },
      rowSpan: 2
    },
    poNo: {
      id: "poNo",
      header: { defaultMessage: "PO No." },
      rowSpan: 2,
      sortable: true,
      sortField: SalesOrderSortListField.poNo
    },
    originalDate: {
      id: "originalDate",
      header: { defaultMessage: "Original Date" },
      rowSpan: 2
    },
    requestDate: {
      id: "requestDate",
      header: { defaultMessage: "Request Date" },
      rowSpan: 2,
      sortable: true,
      sortField: SalesOrderSortListField.reqDeliveryDate
    },
    confirmDate: {
      id: "confirmDate",
      header: { defaultMessage: "Confirm Date" },
      rowSpan: 2
    },
    orderNo: {
      id: "orderNo",
      header: { defaultMessage: "S/O No." },
      rowSpan: 2,
      sortable: true,
      sortField: SalesOrderSortListField.orderNo
    },
    itemNo: {
      id: "itemNo",
      header: { defaultMessage: "Item No." },
      rowSpan: 2
    },
    materialCode: {
      id: "materialCode",
      header: { defaultMessage: "Material Code" },
      rowSpan: 2,
      cellStyle: { minWidth: 220, whiteSpace: "nowrap" }
    },
    oldMaterialNo: {
      id: "oldMaterialNo",
      header: { defaultMessage: "Old Material No." },
      rowSpan: 2
    },
    descriptionSaleText: {
      id: "descriptionSaleText",
      header: { defaultMessage: "Description\n(Sale Text)" },
      rowSpan: 2
    },
    materialDescription: {
      id: "materialDescription",
      header: { defaultMessage: "Material Description" },
      rowSpan: 2,
      cellStyle: { minWidth: 350 }
    },
    batchNo: {
      id: "batchNo",
      header: { defaultMessage: "Batch No." },
      rowSpan: 2
    },
    quantityGroup: {
      id: "quantityGroup",
      header: { defaultMessage: "จำนวน" },
      colSpan: 5,
      textAlign: "center",
      subHeaders: [
        { id: "orderQty", label: "Order", textAlign: "right", minWidth: 80 },
        {
          id: "confirmOrderQty",
          label: "Confirm Order",
          textAlign: "right",
          minWidth: 80
        },
        {
          id: "deliveryQty",
          label: "Delivery",
          textAlign: "right",
          minWidth: 80
        },
        {
          id: "pendingQty",
          label: "Pending",
          textAlign: "right",
          minWidth: 80
        },
        { id: "unit", label: "หน่วย", minWidth: 80 }
      ]
    },
    plant: {
      id: "plant",
      header: { defaultMessage: "Plant" },
      rowSpan: 2,
      textAlign: "right"
    },
    shippingPoint: {
      id: "shippingPoint",
      header: { defaultMessage: "Shipping Point" },
      rowSpan: 2,
      textAlign: "right"
    },
    weightGroup: {
      id: "weightGroup",
      header: { defaultMessage: "น้ำหนัก" },
      colSpan: 4,
      textAlign: "center",
      subHeaders: [
        { id: "orderWeight", label: "Order", textAlign: "right", minWidth: 80 },
        {
          id: "deliveryWeight",
          label: "Delivery",
          textAlign: "right",
          minWidth: 80
        },
        {
          id: "pendingWeight",
          label: "Pending",
          textAlign: "right",
          minWidth: 80
        },
        { id: "weightUnit", label: "หน่วย", minWidth: 80 }
      ]
    },
    pricePerUnit: {
      id: "pricePerUnit",
      header: { defaultMessage: "ราคา/หน่วย" },
      rowSpan: 2,
      textAlign: "right"
    },
    netPrice: {
      id: "netPrice",
      header: { defaultMessage: "ราคารวมสุทธิ" },
      rowSpan: 2,
      textAlign: "right"
    },
    currency: {
      id: "currency",
      header: { defaultMessage: "Currency" },
      rowSpan: 2
    },
    pricingDate: {
      id: "pricingDate",
      header: { defaultMessage: "Pricing Date" },
      rowSpan: 2
    },
    productionFlag: {
      id: "productionFlag",
      header: { defaultMessage: "Production Flag" },
      rowSpan: 2
    },
    deliveryToleranceGroup: {
      id: "deliveryToleranceGroup",
      header: { defaultMessage: "Delivery Tolerance" },
      colSpan: 2,
      textAlign: "center",
      subHeaders: [
        {
          id: "underPercent",
          label: "Under (%)",
          textAlign: "center",
          minWidth: 100
        },
        {
          id: "overPercent",
          label: "Over (%)",
          textAlign: "center",
          minWidth: 100
        }
      ]
    },
    prNumberOs: {
      id: "prNumberOs",
      header: { defaultMessage: "PR Number (OS)" },
      rowSpan: 2
    },
    prItemOs: {
      id: "prItemOs",
      header: { defaultMessage: "PR Item (OS)" },
      rowSpan: 2
    },
    createBy: {
      id: "createBy",
      header: { defaultMessage: "Create by" },
      rowSpan: 2
    },
    createDate: {
      id: "createDate",
      header: { defaultMessage: "Create Date" },
      rowSpan: 2,
      sortable: true,
      sortField: SalesOrderSortListField.createDate
    },
    saleGroup: {
      id: "saleGroup",
      header: { defaultMessage: "Sale group" },
      rowSpan: 2
    },
    saleEmployeeName: {
      id: "saleEmployeeName",
      header: { defaultMessage: "Sale Employee Name" },
      rowSpan: 2
    },
    rejection: {
      id: "rejection",
      header: { defaultMessage: "Rejection" },
      rowSpan: 2
    },
    deliveryBlock: {
      id: "deliveryBlock",
      header: { defaultMessage: "Delivery Block" },
      rowSpan: 2
    },
    overdue1: {
      id: "overdue1",
      header: { defaultMessage: "Overdue 1" },
      rowSpan: 2,
      textAlign: "center",
      tooltip: "เกินวันที่ Request"
    },
    overdue2: {
      id: "overdue2",
      header: { defaultMessage: "Overdue 2" },
      rowSpan: 2,
      textAlign: "center",
      tooltip: "เกินวันที่ Request"
    },
    attentionType: {
      id: "attentionType",
      header: { defaultMessage: "Attention Type" },
      rowSpan: 2
    }
  };

  const renderHeaderCell = column => (
    <TableCellHeader
      key={column.id}
      rowSpan={column.rowSpan}
      colSpan={column.colSpan}
      textAlign={column.textAlign}
      direction={
        column.sortable && sort.sort === column.sortField
          ? getArrowDirection(sort.asc)
          : undefined
      }
      arrowPosition={column.sortable ? "right" : undefined}
      onClick={column.sortable ? () => onSort(column.sortField) : undefined}
    >
      <MyTypography
        variant="subtitle3"
        className={column.tooltip ? classes.cellHeader : undefined}
        style={{ whiteSpace: "pre-line" }}
      >
        {intl.formatMessage(column.header)}
        {column.tooltip && (
          <Tooltip
            title={
              <MyTypography variant="caption">{column.tooltip}</MyTypography>
            }
            placement="bottom"
            classes={{ tooltip: classes.tooltip }}
          >
            <img
              alt="info-filled"
              src={infoFilled}
              className={classes.infoFilled}
            />
          </Tooltip>
        )}
      </MyTypography>
    </TableCellHeader>
  );

  const renderSubHeaderRow = columns => {
    const subHeaderColumns = columns.filter(col => col.subHeaders);

    if (subHeaderColumns.length === 0) {
      return null;
    }

    return (
      <TableRow>
        {subHeaderColumns.map(col =>
          col.subHeaders.map(subHeader => (
            <TableCellHeader
              textAlign={subHeader.textAlign}
              align={subHeader.textAlign}
              key={`${col.id}-${subHeader.id}`}
              style={{ minWidth: subHeader.minWidth }}
              className={classNames(classes.customCell, classes.thDelivery)}
            >
              <span className={classes.delivery}>{subHeader.label}</span>
            </TableCellHeader>
          ))
        )}
      </TableRow>
    );
  };

  const renderBodyCell = (
    column,
    item: SoldTo["orderLines"][0],
    index: number
  ) => {
    switch (column.id) {
      case "itemStatus":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {item?.eOrderingItemStatus || ""}
            </MyTypography>
          </TableCell>
        );

      case "sapStatus":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">{item?.sapStatus || ""}</MyTypography>
          </TableCell>
        );

      case "orderTrackingStatus":
        return (
          <TableCell key={column.id}>
            {item?.orderTrackingStatus ? (
              <div className={classes.rowFlex}>
                <div className={classes.OrderTrackStatus}></div>
                <div className={classNames(classes.rowFlex, classes.flexSpace)}>
                  <MyTypography variant="body3">
                    {item?.orderTrackingStatus}
                  </MyTypography>
                  <Button
                    id={`orderTrackingUrl-${index}`}
                    variant="contained"
                    color="secondary"
                    className={classes.eyeIconStyle}
                    onClick={() => handleOrderTrack(item?.trackingUrl)}
                  >
                    <InlineSVG src={eyeIcon} />
                  </Button>
                </div>
              </div>
            ) : (
              "-"
            )}
          </TableCell>
        );

      case "saleOrganization":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">{item?.salesOrg || ""}</MyTypography>
          </TableCell>
        );

      case "orderType":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {item?.orderType || "-"}
            </MyTypography>
          </TableCell>
        );

      case "billTo":
        return (
          <TableCell key={column.id} style={{ minWidth: 400 }}>
            <MyTypography variant="body3">{item?.billTo || "-"}</MyTypography>
          </TableCell>
        );

      case "shipTo":
        return (
          <TableCell key={column.id} style={{ minWidth: 400 }}>
            <MyTypography variant="body3">{item?.shipTo || "-"}</MyTypography>
          </TableCell>
        );

      case "unloadingPoint":
        return (
          <TableCell key={column.id} style={{ minWidth: 250 }}>
            <MyTypography variant="body3">
              {item?.unloadingPoint || "-"}
            </MyTypography>
          </TableCell>
        );

      case "paymentTerm":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {item?.paymentTerm || "-"}
            </MyTypography>
          </TableCell>
        );

      case "headerNote":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {item?.headerNote || "-"}
            </MyTypography>
          </TableCell>
        );

      case "itemNote":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">{item?.itemNote || "-"}</MyTypography>
          </TableCell>
        );

      case "poNo":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">{item?.poNo || ""}</MyTypography>
          </TableCell>
        );

      case "originalDate":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {isBomChild(item) ? "-" : item?.originalRequestDate || ""}
            </MyTypography>
          </TableCell>
        );

      case "requestDate":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {isBomChild(item) ? "-" : item?.reqDeliveryDate || ""}
            </MyTypography>
          </TableCell>
        );

      case "confirmDate":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3" className={classes.infoDark}>
              {isBomChild(item) ? "-" : item?.eOrderingConfirmDate || ""}
            </MyTypography>
          </TableCell>
        );

      case "orderNo":
        return (
          <TableCell key={column.id}>
            <MyTypography
              id={`orderNo-${index}`}
              variant="subtitle3"
              className={classNames(classes.infoDark, classes.cursorPointer)}
              onClick={() => viewOrder(item)}
            >
              {item?.orderNo || ""}
            </MyTypography>
          </TableCell>
        );

      case "itemNo":
        return (
          <TableCell key={column.id}>
            <MyTypography variant={isBomChild(item) ? "body3" : "subtitle3"}>
              {item?.itemNo || ""}
            </MyTypography>
          </TableCell>
        );

      case "materialCode":
        return (
          <TableCell key={column.id} style={column.cellStyle}>
            <MyTypography
              style={{ display: "flex" }}
              variant={isBomChild(item) ? "body3" : "subtitle3"}
            >
              {isBomChild(item) && (
                <InlineSVG
                  className={
                    getArrowDirection(sort.asc) === "asc" ? "" : classes?.flip
                  }
                  src={BomArrow}
                  width={24}
                  height={24}
                  style={{ marginRight: "10px" }}
                />
              )}
              {item?.matNo || ""}
            </MyTypography>
          </TableCell>
        );

      case "oldMaterialNo":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {item?.oldMaterialNo || "-"}
            </MyTypography>
          </TableCell>
        );

      case "descriptionSaleText":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {item?.descriptionSaleText || "-"}
            </MyTypography>
          </TableCell>
        );

      case "materialDescription":
        return (
          <TableCell key={column.id} style={column.cellStyle}>
            <MyTypography variant={isBomChild(item) ? "body3" : "subtitle3"}>
              {item?.matDesc || ""}
            </MyTypography>
          </TableCell>
        );

      case "batchNo":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {isBomParent(item) ? "-" : item?.batchNo || "-"}
            </MyTypography>
          </TableCell>
        );

      case "quantityGroup":
        return (
          <React.Fragment key={column.id}>
            <TableCell
              key={`${column.id}-orderQty`}
              align="right"
              style={{ minWidth: 80 }}
            >
              <MyTypography variant="body3">
                {item?.orderQty ? formatNumber(item?.orderQty) : ""}
              </MyTypography>
            </TableCell>
            <TableCell
              key={`${column.id}-confirmOrderQty`}
              align="right"
              style={{ minWidth: 80 }}
            >
              <MyTypography variant="body3">
                {item?.confirmOrderQty
                  ? formatNumber(item?.confirmOrderQty)
                  : ""}
              </MyTypography>
            </TableCell>
            <TableCell
              key={`${column.id}-deliveryQty`}
              align="right"
              style={{ minWidth: 80 }}
            >
              <MyTypography variant="body3">
                {item?.deliveryQty ? formatNumber(item?.deliveryQty) : ""}
              </MyTypography>
            </TableCell>
            <TableCell
              key={`${column.id}-pendingQty`}
              align="right"
              style={{ minWidth: 80 }}
            >
              <MyTypography variant="body3">
                {item?.pendingQty ? formatNumber(item?.pendingQty) : ""}
              </MyTypography>
            </TableCell>
            <TableCell key={`${column.id}-unit`} style={{ minWidth: 80 }}>
              <MyTypography variant="body3">{item?.unit || ""}</MyTypography>
            </TableCell>
          </React.Fragment>
        );

      case "plant":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3" align="right">
              {isBomChild(item) ? "-" : item?.plant || ""}
            </MyTypography>
          </TableCell>
        );

      case "shippingPoint":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3" align="right">
              {isBomChild(item) ? "-" : item?.shippingPoint || ""}
            </MyTypography>
          </TableCell>
        );

      case "weightGroup":
        return (
          <React.Fragment key={column.id}>
            <TableCell
              key={`${column.id}-orderWeight`}
              style={{ minWidth: 80 }}
            >
              <MyTypography variant="body3" align="right">
                {item?.orderWeight ? formatNumber(item?.orderWeight) : "0.0"}
              </MyTypography>
            </TableCell>
            <TableCell
              key={`${column.id}-deliveryWeight`}
              style={{ minWidth: 80 }}
            >
              <MyTypography variant="body3" align="right">
                {item?.deliveryWeight
                  ? formatNumber(item?.deliveryWeight)
                  : "0.0"}
              </MyTypography>
            </TableCell>
            <TableCell
              key={`${column.id}-pendingWeight`}
              style={{ minWidth: 80 }}
            >
              <MyTypography variant="body3" align="right">
                {item?.pendingWeight
                  ? formatNumber(item?.pendingWeight)
                  : "0.0"}
              </MyTypography>
            </TableCell>
            <TableCell key={`${column.id}-weightUnit`} style={{ minWidth: 80 }}>
              <MyTypography variant="body3">
                {item?.weightUnit || ""}
              </MyTypography>
            </TableCell>
          </React.Fragment>
        );

      case "pricePerUnit":
        return (
          <TableCell key={column.id} align="right">
            <MyTypography variant="body3">
              {isBomChild(item) ? (
                "-"
              ) : item?.netPrice ? (
                <DecimalFormat
                  value={Number(item?.netPrice)}
                  countDecimal={2}
                />
              ) : (
                ""
              )}
            </MyTypography>
          </TableCell>
        );

      case "netPrice":
        return (
          <TableCell key={column.id} align="right">
            <MyTypography variant="body3">
              {isBomChild(item) ? (
                "-"
              ) : item?.netValue ? (
                <DecimalFormat
                  value={Number(item?.netValue)}
                  countDecimal={2}
                />
              ) : (
                ""
              )}
            </MyTypography>
          </TableCell>
        );

      case "currency":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {isBomChild(item) ? "-" : item?.currency || ""}
            </MyTypography>
          </TableCell>
        );

      case "pricingDate":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">{item?.priceDate}</MyTypography>
          </TableCell>
        );

      case "productionFlag":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {item?.productionFlag || "-"}
            </MyTypography>
          </TableCell>
        );

      case "deliveryToleranceGroup":
        return (
          <React.Fragment key={column.id}>
            <TableCell
              key={`${column.id}-under`}
              align="center"
              style={{ minWidth: 100 }}
            >
              <MyTypography variant="body3">
                {isBomChild(item) ? "-" : item?.deliveryToleranceUnder || 0}
              </MyTypography>
            </TableCell>
            <TableCell
              key={`${column.id}-over`}
              align="center"
              style={{ minWidth: 100 }}
            >
              <MyTypography variant="body3">
                {isBomChild(item) ? "-" : item?.deliveryToleranceOver || 0}
              </MyTypography>
            </TableCell>
          </React.Fragment>
        );

      case "prNumberOs":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {isBomParent(item) ? "-" : item?.prNumberOs || "-"}
            </MyTypography>
          </TableCell>
        );

      case "prItemOs":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {isBomParent(item) ? "-" : item?.prItemOs || "-"}
            </MyTypography>
          </TableCell>
        );

      case "createBy":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {item?.eOrderingCreateBy || ""}
            </MyTypography>
          </TableCell>
        );

      case "createDate":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {item?.createDate || ""}
            </MyTypography>
          </TableCell>
        );

      case "saleGroup":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {item?.salesGroup || ""}
            </MyTypography>
          </TableCell>
        );

      case "saleEmployeeName":
        return (
          <TableCell key={column.id} style={{ minWidth: 250 }}>
            <MyTypography variant="body3">
              {item?.salesEmployeeName || "-"}
            </MyTypography>
          </TableCell>
        );

      case "rejection":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">{item?.rejection || ""}</MyTypography>
          </TableCell>
        );

      case "deliveryBlock":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {item?.deliveryBlock || ""}
            </MyTypography>
          </TableCell>
        );

      case "overdue1":
        return (
          <TableCell key={column.id} align="center">
            <MyTypography variant="body3">
              {item?.eOrderingOverdue1 ? (
                <img alt="warning-light" src={warningLight} />
              ) : (
                ""
              )}
            </MyTypography>
          </TableCell>
        );

      case "overdue2":
        return (
          <TableCell key={column.id} align="center">
            <MyTypography variant="body3">
              {item?.eOrderingOverdue2 ? (
                <img alt="warning-light" src={warningLight} />
              ) : (
                ""
              )}
            </MyTypography>
          </TableCell>
        );

      case "attentionType":
        return (
          <TableCell key={column.id}>
            <MyTypography variant="body3">
              {item?.eOrderingRequiredAttentionFlag || "-"}
            </MyTypography>
          </TableCell>
        );

      default:
        return null;
    }
  };

  const COLUMN_ORDER = {
    listOfSalesOrder: [
      "attentionType",
      "itemStatus",
      "sapStatus",
      "createBy",
      "createDate",
      "saleOrganization",
      "saleGroup",
      "poNo",
      "originalDate",
      "requestDate",
      "confirmDate",
      "orderNo",
      "itemNo",
      "materialCode",
      "materialDescription",
      "quantityGroup",
      "plant",
      "shippingPoint",
      "weightGroup",
      "pricePerUnit",
      "netPrice",
      "currency",
      "pricingDate",
      "rejection",
      "deliveryBlock",
      "overdue1",
      "overdue2"
    ],
    listOfSalesOrderTracking: [
      "itemStatus",
      "sapStatus",
      "orderTrackingStatus",
      "saleOrganization",
      "orderType",
      "billTo",
      "shipTo",
      "unloadingPoint",
      "paymentTerm",
      "headerNote",
      "itemNote",
      "poNo",
      "originalDate",
      "requestDate",
      "confirmDate",
      "orderNo",
      "itemNo",
      "materialCode",
      "oldMaterialNo",
      "descriptionSaleText",
      "materialDescription",
      "batchNo",
      "quantityGroup",
      "plant",
      "shippingPoint",
      "weightGroup",
      "pricePerUnit",
      "netPrice",
      "currency",
      "pricingDate",
      "productionFlag",
      "deliveryToleranceGroup",
      "prNumberOs",
      "prItemOs",
      "createBy",
      "createDate",
      "saleGroup",
      "saleEmployeeName",
      "rejection",
      "deliveryBlock",
      "overdue1",
      "overdue2",
      "attentionType"
    ]
  };

  const getTableColumns = (isSaleOrderTracking: boolean) => {
    const columnKeys = isSaleOrderTracking
      ? COLUMN_ORDER.listOfSalesOrderTracking
      : COLUMN_ORDER.listOfSalesOrder;
    return columnKeys.map(key => COLUMN_DEFINITIONS[key]);
  };

  const columns = getTableColumns(isSaleOrderTracking);

  return (
    <CollapseSoldTo
      key={`${soldTo.soldTo} - ${soldTo.soldToName1}`}
      index={index}
      name={`${soldTo.soldTo} - ${soldTo.soldToName1}`}
    >
      <div className={classes.root} ref={containerRef}>
        <TableContainer className={classes.tableContainer}>
          <Table>
            <TableHead>
              <TableRow>
                {columns.map(column => renderHeaderCell(column))}
              </TableRow>
              {renderSubHeaderRow(columns)}
            </TableHead>
            <TableBody>
              {renderCollection(item.orderLines, (lineItem, index) => (
                <TableRow
                  className={classNames({
                    [classes.rowOverDue]:
                      lineItem.eOrderingOverdue1 || lineItem.eOrderingOverdue2
                  })}
                  key={`${lineItem.itemNo}-${index}`}
                >
                  {columns.map(column =>
                    renderBodyCell(column, lineItem, index)
                  )}
                </TableRow>
              ))}
            </TableBody>
            <TableFooter className={classes.tableFooter}>
              {soldTo.summary?.quantityData?.map((quantity, index) => (
                <TableRow key={quantity?.quantityUnit}>
                  <TableCellHeader
                    colSpan={isSaleOrderTracking ? 20 : 14}
                    style={{
                      ...getSummaryEmptyStyle(
                        index,
                        soldTo.summary?.quantityData.length
                      ),
                      background: "#fff",
                      borderRight: "none"
                    }}
                  >
                    {index === 0 && (
                      <MyTypography variant="subtitle3">
                        {intl.formatMessage({
                          defaultMessage: "Summary:"
                        })}
                      </MyTypography>
                    )}
                  </TableCellHeader>
                  <TableCellHeader
                    colSpan={isSaleOrderTracking ? 2 : 1}
                    textAlign="right"
                  >
                    <TotalText unit={quantity?.quantityUnit} />
                  </TableCellHeader>
                  <TableCellHeader textAlign="right">
                    <MyTypography variant="subtitle3">
                      {formatNumber(quantity?.orderQty)}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader textAlign="right">
                    <MyTypography variant="subtitle3">
                      {formatNumber(quantity?.confirmOrderQty)}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader textAlign="right">
                    <MyTypography variant="subtitle3">
                      {formatNumber(quantity?.deliveryQty)}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader textAlign="right">
                    <MyTypography variant="subtitle3">
                      {formatNumber(quantity?.pendingQty)}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader>
                    <MyTypography variant="subtitle3">
                      {quantity?.quantityUnit}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    colSpan={2}
                    textAlign="right"
                    style={getSummaryEmptyStyle(
                      index,
                      soldTo.summary?.quantityData.length
                    )}
                  >
                    {index === 0 && <TotalText unit={"ทั้งหมด"} />}
                  </TableCellHeader>
                  <TableCellHeader
                    textAlign="right"
                    style={getSummaryEmptyStyle(
                      index,
                      soldTo.summary?.quantityData.length
                    )}
                  >
                    {index === 0 && (
                      <MyTypography variant="subtitle3">
                        {formatNumber(soldTo?.summary?.orderWeight)}
                      </MyTypography>
                    )}
                  </TableCellHeader>
                  <TableCellHeader
                    textAlign="right"
                    style={getSummaryEmptyStyle(
                      index,
                      soldTo.summary?.quantityData.length
                    )}
                  >
                    {index === 0 && (
                      <MyTypography variant="subtitle3">
                        {formatNumber(soldTo?.summary?.deliveryWeight)}
                      </MyTypography>
                    )}
                  </TableCellHeader>
                  <TableCellHeader
                    textAlign="right"
                    style={getSummaryEmptyStyle(
                      index,
                      soldTo.summary?.quantityData.length
                    )}
                  >
                    {index === 0 && (
                      <MyTypography variant="subtitle3">
                        {formatNumber(soldTo?.summary?.pendingWeight)}
                      </MyTypography>
                    )}
                  </TableCellHeader>
                  <TableCellHeader
                    style={getSummaryEmptyStyle(
                      index,
                      soldTo.summary?.quantityData.length
                    )}
                  >
                    {index === 0 && (
                      <MyTypography variant="subtitle3">
                        {mergeUnit("weightUnit")}
                      </MyTypography>
                    )}
                  </TableCellHeader>
                  <TableCellHeader
                    textAlign="right"
                    style={getSummaryEmptyStyle(
                      index,
                      soldTo.summary?.quantityData.length
                    )}
                  >
                    {index === 0 && (
                      <MyTypography variant="subtitle3">
                        {soldTo?.summary?.netPrice ? (
                          <DecimalFormat
                            value={Number(soldTo?.summary?.netPrice)}
                            countDecimal={2}
                          />
                        ) : (
                          0
                        )}
                      </MyTypography>
                    )}
                  </TableCellHeader>
                  <TableCellHeader
                    textAlign="right"
                    style={getSummaryEmptyStyle(
                      index,
                      soldTo.summary?.quantityData.length
                    )}
                  >
                    {index === 0 && (
                      <MyTypography variant="subtitle3">
                        {soldTo?.summary?.netValue ? (
                          <DecimalFormat
                            value={Number(soldTo?.summary?.netValue)}
                            countDecimal={2}
                          />
                        ) : (
                          0
                        )}
                      </MyTypography>
                    )}
                  </TableCellHeader>
                  <TableCellHeader
                    style={getSummaryEmptyStyle(
                      index,
                      soldTo.summary?.quantityData.length
                    )}
                  >
                    {index === 0 && (
                      <MyTypography variant="subtitle3">
                        {soldTo?.summary?.currency}
                      </MyTypography>
                    )}
                  </TableCellHeader>
                  <TableCellHeader
                    colSpan={isSaleOrderTracking ? 15 : 5}
                    style={{
                      ...getSummaryEmptyStyle(
                        index,
                        soldTo.summary?.quantityData.length
                      ),
                      background: "#fff"
                    }}
                  ></TableCellHeader>
                </TableRow>
              ))}
            </TableFooter>
          </Table>
        </TableContainer>
        {soldTo ? <StickyHorizontalScrollBar container={containerRef} /> : null}
      </div>
    </CollapseSoldTo>
  );
};

export default TableData;
